var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.getRecords(1)
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "flex justify-content-between" },
              [
                _c("div", { staticClass: "flex flex_gap_10 flex-grow-1" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Поиск по препарату")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.title,
                          expression: "filter.title",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Препарат..." },
                      domProps: { value: _vm.filter.title },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.filter, "title", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Тип скрытия")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.hideStatus,
                            expression: "filter.hideStatus",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.filter,
                              "hideStatus",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.hideStatuses, function (s) {
                        return _c("option", { domProps: { value: s.id } }, [
                          _vm._v(_vm._s(s.title)),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("LoadingButton", {
                  attrs: {
                    title: "Показать",
                    type: "submit",
                    loading: _vm.loading.records,
                    color: _vm.$constants.SUCCESS_COLOR,
                    onClick: () => {},
                    className: "btn btn-outline-success",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading.records,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading.records
            ? _c("div", [
                _c(
                  "table",
                  { staticClass: "table table-hover table-sm mt-0" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (r, i) {
                        return _c("tr", { key: r.id }, [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                i +
                                  1 +
                                  (_vm.paginator.current_page - 1) *
                                    _vm.paginator.per_page
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(r?.service_drug?.title ?? r.id)),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.hideStatuses[r.type_id]?.title)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              (r.service_drug?.scan_tasks ?? []).length
                                ? _c("ScanFilters", {
                                    attrs: {
                                      records: r.service_drug.scan_tasks,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(r.service_drug?.actual_stat?.call)),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex_gap_10 align-items-center",
                              },
                              [
                                r.service_drug?.actual_stat?.price
                                  ? _c("LoadStoreTrendData", {
                                      attrs: {
                                        type: "price",
                                        record: r.service_drug.actual_stat,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(r.service_drug?.actual_stat?.price)
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex_gap_10 align-items-center",
                              },
                              [
                                r.service_drug?.actual_stat
                                  ? _c("LoadStoreTrendData", {
                                      attrs: {
                                        trend:
                                          +r.service_drug.actual_stat
                                            .store_trend,
                                        record: r.service_drug.actual_stat,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(r.service_drug?.actual_stat?.stores)
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              r.type_id === 2
                                ? [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(r.data?.hideReasonText) +
                                        "\n              "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(r.data?.comment) +
                                        "\n              "
                                    ),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.printDate(r.created_at, "DD.MM.YYYY"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-default",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.newTaskModal(r)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "icon-fa icon-fa-edit" })]
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.paginator
                  ? _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 10,
                            "margin-pages": 2,
                            "click-handler": _vm.getRecords,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.paginator.current_page,
                            callback: function ($$v) {
                              _vm.$set(_vm.paginator, "current_page", $$v)
                            },
                            expression: "paginator.current_page",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [
        _vm._v("Результаты мониторинга препаратов в статистике 003sm"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Тип")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "70px" } }),
        _vm._v(" "),
        _c("th", { attrs: { width: "100px" } }, [_vm._v("спрос")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "100px" } }, [_vm._v("цена")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "100px" } }, [_vm._v("наличие")]),
        _vm._v(" "),
        _c("th", [_vm._v("комментарий")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "100px" } }, [_vm._v("создано")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "70px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }